module.exports = __webpack_public_path__ + "2df2ea33727785f2d9801a81bedfa07a.jpg";